import { sendRequest } from 'best-modules/vue-utils'
import { Query } from 'best-modules/utils'
import {
  NotificationListResponse,
  NotificationUnreadCountResponse,
} from '@/utils/types/notification'

const notificationList = (
  query: Query = {}
): Promise<NotificationListResponse> => {
  return sendRequest({
    name: 'getNotificationList',
    method: 'get',
    url: {
      url: '/json/notification/system',
      query,
    },
  })
}

const notificationUnreadCount = (): Promise<NotificationUnreadCountResponse> => {
  return sendRequest({
    name: 'getNotificationUnreadCount',
    method: 'get',
    url: '/json/notification/system/unreadCount',
  })
}

const notificationMarkAsRead = (id: number): Promise<void> => {
  return sendRequest({
    name: 'notificationMarkAsRead',
    method: 'patch',
    url: `/json/notification/system/markAsRead/${id}`,
  })
}

const notificationMarkAllAsRead = (): Promise<void> => {
  return sendRequest({
    name: 'notificationMarkAllAsRead',
    method: 'patch',
    url: '/json/notification/system/markAllAsRead',
  })
}

export {
  notificationList,
  notificationMarkAllAsRead,
  notificationMarkAsRead,
  notificationUnreadCount,
}
